export const BRANDMANAGER_URL = '/brandmanager';

export const getBrandmanagerURL = (slug: string) => {
  if (!slug) return BRANDMANAGER_URL;

  return `${BRANDMANAGER_URL}/${slug}/page-reach`;
};
